import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop({ children, behavior = 'auto' }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const target = hash
        ? document.getElementById(decodeURIComponent(hash.slice(1)))
        : null;

      if (target) {
        target.scrollIntoView({ behavior });
      } else {
        window.scrollTo({ top: 0, left: 0, behavior });
      }
    }
  }, [pathname, hash, behavior]);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const sections = Array.from(document.querySelectorAll('section[id]'));
    if (!sections.length) return undefined;

    const updateHash = () => {
      const navbarOffset = 100;
      const activeSection =
        window.scrollY <= navbarOffset
          ? sections[0]
          : sections
              .filter(
                (section) => section.getBoundingClientRect().top <= navbarOffset,
              )
              .at(-1);

      if (activeSection) {
        const nextHash = `#${activeSection.id}`;
        if (window.location.hash !== nextHash) {
          const hashPath = pathname === '/' || pathname === '/home'
            ? '/'
            : pathname;
          window.history.replaceState(
            null,
            '',
            `${hashPath}${nextHash}`,
          );
        }
      }
    };

    updateHash();
    window.addEventListener('scroll', updateHash, { passive: true });

    return () => window.removeEventListener('scroll', updateHash);
  }, [pathname]);

  return children || null;
}
